import { atom } from 'jotai';
import { $SearchParams } from './remix';
export const $EmailTraffic = atom((get) => {
    const sp = get($SearchParams);
    return {
        msgId: sp.get('msg_id') || '',
    };
});
$EmailTraffic.debugLabel = '$EmailTraffic';
